// import * as go from "gojs/release/go-module";
// import * as go from "gojs/release/go-debug-module";
const go = require("gojs");
import { getPaletteTaskType } from './nodeTemplates'
import featureFlags from '../featureFlags'
import * as taskTypeEnum from '../enums/taskTypes'

const $ = go.GraphObject.make;

export default class Palette {
  constructor(paletteDivId, taskTypes) {
    this.paletteDivId = paletteDivId

    const frequentlyUsed = taskTypes.find(tt => tt.frequentlyUsed).frequentlyUsed

    if (this.paletteDivId === 'processPaletteDiv') {
      this.taskTypes = taskTypes.filter(tt => !tt.frequentlyUsed && !frequentlyUsed.find(x => x.taskTypeGuid == tt.taskTypeGuid))
    } else {
      this.taskTypes = frequentlyUsed
    }
  }

  init() {
    this.palette = $(go.Palette, this.paletteDivId,  // must name or refer to the DIV HTML element
      {
        // Instead of the default animation, use a custom fade-down
        "animationManager.initialAnimationStyle": go.AnimationManager.None,
        "InitialAnimationStarting": animateFadeDown, // Instead, animate with this function

        nodeTemplate: getPaletteTaskType(),
        // model: new go.GraphLinksModel(paletteModel)
      });
    this.palette.nodeTemplateMap.add("Comment", getPaletteTaskType());
  }

  async load(theme, diagramHasEndTask) {
    const enableFileCopyTask = await featureFlags.checkFeatureFlag('enableFileCopyTask');

    const excludedTaskTypes = [
      taskTypeEnum.SYSTEM_START.guid, // System Start
      taskTypeEnum.COMMAND_LINE.guid, // Command Line
      'a3af2110-4894-11e3-9ba7-49b885e55bef', // File Upload
      '59b82d40-105c-4af0-847b-8b347a9ce548', // Box File Copy
      taskTypeEnum.FORM.guid // legacy form
    ];

    if (diagramHasEndTask)
      excludedTaskTypes.push(taskTypeEnum.SYSTEM.guid); // System End

    if (!enableFileCopyTask)
      excludedTaskTypes.push(taskTypeEnum.LOCAL_FILE_COPY.guid); // Local File Copy

    const taskTypes = this.taskTypes.filter(taskType => {
      return !excludedTaskTypes.includes(taskType.taskTypeGuid.toLowerCase())
    })


    if (this.paletteDivId === 'processPaletteDiv') {
      if (enableFileCopyTask) taskTypes.find(tt => tt.taskTypeGuid.toLowerCase() === taskTypeEnum.LOCAL_FILE_COPY.guid).taskTypeName = 'File Copy'

      taskTypes.sort(sortByName)
    } 

    this.paletteModel = taskTypes.map(taskType => {
      
      const result = {
        itaskState: null, // prevents black color rectangle after dropping onto diagram
        tasktypesid: taskType.taskTypeGuid,
        taskName: taskType.taskTypeName,
        name: `(${taskType.taskTypeName})`,
        taskshape: taskType.imagePath,

        // milestone tasks get auto configd
        taskConfig: taskType.taskTypeGuid == taskTypeEnum.MILESTONE.guid ? true : false, 
        
        taskRecipients: false,
        height: 86,
        width: 86,
        theme,
        disabled: taskType.disabled
      }

      if (taskType.taskTypeGuid.toLowerCase() === taskTypeEnum.SYSTEM.guid) // end
        result.category = "End";

      if (taskType.executionMode == 'System' || taskType.executionMode == 'SystemWithNotification' || taskType.executionMode == 'SystemIfNoRecips')
        result.taskRecipients = null
      else if (taskType.executionMode == 'SystemWithRecipsAndNotification') 
        result.taskConfig = null

      return result
    });

    if (this.paletteDivId === 'processPaletteDiv') {
      this.paletteModel.push({
        category: 'Comment',
        taskName: "Comment",
        name: "Comment",
        taskshape: '/assets/taskshapes/comment.svg',
        text: "Comment",
        taskConfig: false,
        taskRecipients: false,
        theme
      });
    }

    this.palette.model = new go.GraphLinksModel(this.paletteModel);
  }

  removeEndTask() {
    this.paletteModel = this.paletteModel.filter(task => task.category !== 'End');
    this.palette.model = new go.GraphLinksModel(this.paletteModel);
  }
}

function animateFadeDown(e) {
  var diagram = e.diagram;
  var animation = new go.Animation();
  animation.isViewportUnconstrained = true; // So Diagram positioning rules let the animation start off-screen
  animation.easing = go.Animation.EaseOutExpo;
  animation.duration = 900;
  // Fade "down", in other words, fade in from above
  animation.add(diagram, 'position', diagram.position.copy().offset(0, 200), diagram.position);
  animation.add(diagram, 'opacity', 0, 1);
  animation.start();
}

function sortByName(a, b) {
  var nameA = a.taskTypeName.toUpperCase(); // ignore upper and lowercase
  var nameB = b.taskTypeName.toUpperCase(); // ignore upper and lowercase
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  // names must be equal
  return 0;
}

function taskTypeFilter(taskType) {
  const excludedTaskTypes = [
    taskTypeEnum.SYSTEM_START.guid // System Start
  ];

  return !excludedTaskTypes.includes(taskType.taskTypeGuid.toLowerCase());
}
